// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"quadratic"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M2 13.6429H4.22222L7.55556 19L12 4H22","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const QuadraticIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'quadratic',
    ref,
    icon: element,
  },
));

QuadraticIcon.displayName = 'QuadraticIcon';

export default QuadraticIcon;
